<script setup lang="ts">
import {QBtn, useDialogPluginComponent} from 'quasar'
import Translator from "@/utils/common/Translator.ts";
import DialogCloseIcon from "@/assets/editViewIcons/DialogCloseIcon.vue";
import {PropType} from "vue";
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";
import ClientCache from "@/utils/login/ClientCache.ts";
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import TooltipIcon from "@/assets/editViewIcons/TooltipIcon.vue";
import FieldToFocusUtils from "@/utils/common/FieldToFocusUtils.ts";
import MetaData from "@/utils/common/MetaData.ts";

const props = defineProps({
  title: {type: String, required: true},
  presenter: {type: Object as PropType<EditPresenter>, required: true},
});
const {compactMode} = storeToRefs(useNamaFlagsStore());
const {dialogRef, onDialogCancel} = useDialogPluginComponent();
const fieldIds = ClientCache.fetchTooltipFieldIds(props.presenter?.entityType);

async function onClick(id: string) {
  if (id) {
    let row = -1;
    let gridId = MetaData.getFieldParentDetail0(props.presenter.fetchMetadata(), id, false);
    if (gridId)
      row = props.presenter.fetchGridSelectedLine(gridId) ?? 0;
    await props.presenter.fetchDispatcher().displayTooltip(id, gridId ?? id, row, false);
    await FieldToFocusUtils.focusToField(new FieldToFocusUtils(props.presenter), id, row);
  }
  onDialogCancel();
}

function onCancelClick() {
  onDialogCancel();
}
</script>

<template>

  <q-dialog ref="dialogRef" @hide="onCancelClick">
    <q-card
      class="tw-w-[25%] mobile:tw-w-[80%] tw-h-fit tw-shadow-none dark:tw-text-white dark:tw-bg-namaBackground-deep-dark tw-rounded-2xl tw-bg-namaBackground-deep-light ">
      <q-bar v-if="title" class="tw-text-xs tw-text-namaFontColor-light tw-bg-[#CED4DA] dark:tw-bg-[#212529] dark:tw-text-white tw-h-10">
        <div>{{ Translator.translateId('tooltips') }}</div>
        <q-space/>
        <q-avatar square @click="onCancelClick" class="tw-w-5 nama-avatar-hover tw-cursor-pointer">
          <DialogCloseIcon/>
        </q-avatar>
      </q-bar>
      <div class="tw-w-full tw-h-full tw-p-3 tw-place-self-center">
        <q-card-section class="tw-flex tw-flex-wrap tw-justify-center tw-w-full tw-h-fit tw-max-h-[60vh] tw-gap-5 tw-overflow-y-auto">
          <template v-for="(id, index) in fieldIds" :key="index">
            <q-btn
              outline no-caps
              :title="Translator.translateId(id,presenter.entityType)"
              @click="onClick(id)"
              :dense="compactMode"
              class="tw-w-[45%] mobile:tw-w-full tw-text-primary-light dark:tw-text-primary-dark tw-text-base tw-font-normal tw-rounded-md tw-p-2">
              <TooltipIcon class="tw-size-5 compact:tw-size-[18px] ultra:tw-size-[15px] tw-mr-2"/>
              <div class="tw-text-namaFontColor-light dark:tw-text-white">{{ Translator.translateId(id, presenter.entityType) }}</div>
            </q-btn>
          </template>
        </q-card-section>
      </div>
    </q-card>
  </q-dialog>
</template>

<style scoped>

</style>
